import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import useFocusTrap from '../../hooks/useFocusTrap';
import './ConfirmActionModal.css';

function ConfirmActionModal({ title, message, details, confirmLabel, onConfirm, onCancel, variant }) {
  const { t } = useTranslation();
  const trapRef = useFocusTrap();
  const titleId = useId();
  const messageId = useId();

  return (
    <>
      <div className="confirm-modal-overlay" onClick={onCancel} />
      <div
        ref={trapRef}
        className={`confirm-modal ${variant === 'danger' ? 'confirm-modal--danger' : ''}`}
        role="alertdialog"
        aria-labelledby={titleId}
        aria-describedby={message ? messageId : undefined}
      >
        <div className="confirm-modal-header">
          <h3 id={titleId} className="confirm-modal-title">{title}</h3>
        </div>
        <div className="confirm-modal-body">
          {message && <p id={messageId} className="confirm-modal-message">{message}</p>}
          {details && details.length > 0 && (
            <div className="confirm-modal-details">
              {details.map((detail, i) => (
                <div key={i} className="confirm-modal-detail-row">
                  <span className="confirm-modal-detail-label">{detail.label}</span>
                  <span className="confirm-modal-detail-value">{detail.value}</span>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="confirm-modal-actions">
          <button className="confirm-modal-btn confirm-modal-btn--ghost" onClick={onCancel}>
            {t('common.cancel')}
          </button>
          <button
            className={`confirm-modal-btn ${variant === 'danger' ? 'confirm-modal-btn--danger' : 'confirm-modal-btn--confirm'}`}
            onClick={onConfirm}
          >
            {confirmLabel || t('common.confirm')}
          </button>
        </div>
      </div>
    </>
  );
}

export default ConfirmActionModal;
